export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-dev.ria.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-dev.ria.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-dev.ria.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/ria-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
